import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import home from '@/pages/home'
import largescreen from '@/pages/largeScreen'
import index from '@/pages/index'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'default',
      component: Login
    },
    {
      path: '/largescreen',
      name: 'largescreen',
      component: largescreen
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      children:[
        {
          path: '',
          component: () => import('@/pages/homepage/homepage'),
        },
        {
          path: 'homepage',
          component: () => import('@/pages/homepage/homepage'),
        },
        {
          path: 'personalcenter',
          component: () => import('@/pages/personalcenter/personalcenter'),
        },
        {
          path: 'equipmentmanagement',
          component: () => import('@/pages/equipmentmanagement/equipmentmanagement'),
        },
        {
          path: 'equipmentinspection',
          component: () => import('@/pages/equipmentmanagement/equipmentinspection'),
        },
        {
          path: 'malfunctionmanage',
          component: () => import('@/pages/malfunctionmanage/malfunctionmanage'),
        },
        {
          path: 'speeddelay',
          component: () => import('@/pages/speeddelay/speeddelay'),
        },
        {
          path: 'operatelog',
          component: () => import('@/pages/operatelog/operatelog'),
        },
        {
          path: 'promotions',
          component: () => import('@/pages/promotions/promotions'),
        },
        {
          path: 'remotecontrol',
          component: () => import('@/pages/remotecontrol/remotecontrol'),
        },
        {
          path: 'saledata',
          component: () => import('@/pages/saledata/saledata'),
        },
        {
          path: 'equiptypeconfig',
          component: () => import('@/pages/standardconfig/equiptypeconfig'),
        },
        {
          path: 'standardconfig',
          component: () => import('@/pages/standardconfig/standardconfig'),
        },
        {
          path: 'userlevelconfig',
          component: () => import('@/pages/standardconfig/userlevelconfig'),
        },
        {
          path: 'trafficwarning',
          component: () => import('@/pages/trafficwarning/trafficwarning'),
        },
        {
          path: 'myduty',
          component: () => import('@/pages/myduty/myduty'),
        },
        {
          path: 'usermanagement',
          component: () => import('@/pages/usermanagement/usermanagement'),
        },
        {
          path: 'equipmentuser_detail',
          component: () => import('@/pages/usermanagement/equipmentuser_detail'),
        },
        {
          path: 'logginaccount',
          component: () => import('@/pages/logginaccount/logginaccount'),
        },
        {
          path: 'payconfig',
          component: () => import('@/pages/payconfig/payconfig'),
        },
        {
          path: 'HuiFuAppConfig',
          component: () => import('@/pages/payconfig/HuiFuAppConfig'),
        },
        {
          path: 'HuiFuPaymentConfig',
          component: () => import('@/pages/payconfig/HuiFuPaymentConfig'),
        },
        {
          path: 'HuiFuMemberConfig',
          component: () => import('@/pages/payconfig/HuiFuMemberConfig'),
        },
        {
          path:'formeryearssaledata',
          component:() => import('@/pages/saledata/formeryearssaledata')
        },
        {
          path:'washRecords',
          component:()=>import('@/pages/equipmentmanagement/washRecords')
        },
        {
          path:'calibrationRecords',
          component:()=>import('@/pages/equipmentmanagement/calibrationRecords')
        },
        {
          path:'Person',
          component:()=>import('@/pages/personalcenter/Person')
        },
        {
          path:'UpdateRecord',
          component:()=>import('@/pages/operatelog/UpdateRecord')
        },
        {
          path:'advertisemanagement',
          component:()=>import('@/pages/assistmaintain/advertise/advertiseManagement.vue')
        },
        {
          path:'maintenanceRecord',
          component:()=>import('@/pages/assistmaintain/maintenance/maintenanceRecord.vue')
        },
        {
          path:'teaStorageMaintain',
          component:()=>import('@/pages/equipmentmanagement/teaStorageMaintain.vue')
        }
      ]
    }
  ]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}





// WEBPACK FOOTER //
// ./src/router/index.js